import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import './InformationsRattachementComponent.css';

const MandatEmisApresPaiementComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group className="panelRow">
					<Form.Input
						data-testid="mandatEmisApresPaiementExerRattachement"
						name="exerRattachement"
						label="Année de constitution de la liste"
						value={data?.exerRattachement ?? ''}
						title={data?.exerRattachement ?? ''}
						onChange={handleChange}
						width={8}
						input={{
							maxLength: 4,
						}}
					/>
					<Form.Input
						data-testid="mandatEmisApresPaiementPieceOrigine"
						name="pieceOrigine"
						label="Numéro de la liste de non valeur"
						value={data?.pieceOrigine ?? ''}
						title={data?.pieceOrigine ?? ''}
						onChange={handleChange}
						width={8}
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default MandatEmisApresPaiementComponent;
